import { useEffect, useRef, useState } from 'react';
export const useZendeskChat = ({ fromMobileApp = false, windowZe, } = {}) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const timeoutRef = useRef(null);
    const clearTimeoutCache = () => {
        if (!timeoutRef.current)
            return;
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
    };
    const handleChatVisibility = (isChatOpen) => {
        if (fromMobileApp)
            return;
        const timeout = 0;
        clearTimeoutCache();
        timeoutRef.current = setTimeout(() => {
            const chatCommand = isChatOpen ? 'show' : 'hide';
            windowZe?.('messenger', chatCommand);
        }, timeout);
    };
    const toggleChat = () => {
        setIsChatOpen((prev) => {
            const isChatOpen = !prev;
            const zendeskTarget = 'messenger';
            const zendeskEventName = isChatOpen ? 'open' : 'close';
            windowZe?.(zendeskTarget, zendeskEventName);
            handleChatVisibility(isChatOpen);
            return isChatOpen;
        });
    };
    useEffect(() => {
        if (fromMobileApp) {
            windowZe?.('messenger', 'hide');
        }
        handleChatVisibility(false);
        windowZe?.('messenger:on', 'close', () => {
            setIsChatOpen(false);
            handleChatVisibility(false);
        });
        windowZe?.('messenger:on', 'unreadMessages', (count) => {
            if (typeof count === 'number') {
                setUnreadCount(count);
            }
        });
        return () => {
            clearTimeoutCache();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isChatOpen,
        toggleChat,
        unreadCount,
    };
};
//# sourceMappingURL=useZendeskChat.js.map